var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-flyer clearfix",
      class: [_vm.theme, _vm.wrapperClass, _vm.eventClass],
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-wrapper" },
            [_c("loading", { attrs: { loading: _vm.loading } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.event
        ? _c("event-card-1", {
            attrs: {
              "data-event-id": _vm.event.id,
              event: _vm.event,
              theme: _vm.theme,
              "image-width": 350,
            },
            on: { eventClick: _vm.onEventClicked },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "event-sub-text center" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-primary btn-sm",
            style: {
              "background-color": _vm.buttonBgColorSanitized,
              "border-color": _vm.buttonBgColorSanitized,
              color: _vm.buttonTextColorSanitized,
            },
            attrs: { href: "#" },
            on: { click: _vm.onEventClicked },
          },
          [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _vm.eventNotFound
        ? _c("div", { staticClass: "event-detail-content not-found" }, [
            _c("div", { staticClass: "alert alert-info" }, [
              _vm._v("\n      Event not found\n    "),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/EventFlyer/template.html?vue&type=template&id=16820b19&
// module id = 1048
// module chunks = 0